import React from "react";
import { RouteProps } from "react-router-dom";
import { classNames, hasOwnProperty } from "maven-lib/dist/utils/misc";
import { Footer, FooterProps } from "./Footer";
import { Header, HeaderProps } from "./Header";

interface MainProps extends RouteProps {
  header: HeaderProps;
  footer: FooterProps;
  children: React.ReactNode;
  routeParams?: { [key: string]: string };
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export function Main(props: MainProps) {
  const { header, footer, size } = props;

  const productName = String(process.env.REACT_APP_NAME || "")
    .toLowerCase()
    .split(" ")
    .join("-");

  return (
    <>
      <div
        className={classNames(
          "app-hybrid-layout",
          productName,
          !!header && hasOwnProperty(header, "icon") && !!header.icon && "--with-header-icon",
          !!footer && hasOwnProperty(footer, "dummy") && !!footer.dummy && "--with-footer-dummy"
        )}
      >
        <Header {...header} size={size} />
        <div className="app-hybrid-main">
          <div className="app-hybrid-section">{props.children}</div>
          <Footer {...footer} />
        </div>
      </div>
    </>
  );
}
